import { useState } from "react";
import ReportSelector from "../components/ReportSelector";
import ProfileForm from "../components/ProfileForm";
import "../styles/About.css";

const About = () => {
  const [selectedSection, setSelectedSection] = useState("welcome");

  return (
    <div className="content">
      <h2>Sobre o Sistema</h2>
                <p>O Cronus é um sistema de cashback que auxilia usuários a encontrar serviços de saúde próximos à sua região. Ele automatiza o gerenciamento de informações sobre clínicas e facilita a integração com ferramentas de terceiros.</p>
                <h3>Características Principais:</h3>
                <ul>
                    <li>Localização de serviços de saúde por região</li>
                    <li>Cashback em consultas e procedimentos</li>
                    <li>Relatórios em tempo real</li>
                    <li>Integração com sua API aberta</li>
                </ul>
                <h3>Benefícios:</h3>
                <p>Com o Cronus, os usuários economizam tempo e dinheiro ao acessar serviços de saúde, enquanto as clínicas aumentam a produtividade, reduzem erros e melhoram a satisfação dos pacientes.</p>
                <h3>Desenvolvimento e Futuras Atualizações:</h3>
                <p>Desde seu lançamento em 2024, o Cronus recebe atualizações constantes para adicionar novas funcionalidades e aprimorar a experiência do usuário. Em breve, teremos integrações adicionais com plataformas de IA para maior automação e personalização.</p>
                <h3>Contato:</h3>
                <p>Para suporte ou dúvidas, entre em contato pelo email <a href="mailto:support@cronus.com">support@cronus.com</a> ou visite nossa <a href="#">página de ajuda</a>.</p>
    </div>
  );
};

export default About;
